import { call, put, all } from 'redux-saga/effects';
import { HTTP_CODE } from '@airasia-common/libraries/constants';

function* genericApiSaga({
  completed,
  failed,
  gatewayCall,
  beforeCompleted,
  onResponse,
}) {
  const started = Date.now();
  const response = yield call(gatewayCall);
  const payload =
    response.body &&
    typeof response.body === 'object' &&
    !Array.isArray(response.body)
      ? { ...response.body, ...response.extraData }
      : response.body;

  if (onResponse) {
    yield onResponse(response);
  }

  switch (response.status) {
    case HTTP_CODE.NOT_FOUND:
      console.log(`[API] ${started} - failed after: ${Date.now() - started}ms`);
      if (failed) {
        yield put(failed(response.body, started));
      }
      return;
    case HTTP_CODE.TEMPORARILY_UNAVAILABLE:
    case HTTP_CODE.NOT_EXIST:
      console.log(
        `[API] ${started} - completed - no data after: ${Date.now() -
          started}ms`
      );
      yield put(completed(payload, started));
      break;
    case HTTP_CODE.OK:
    case HTTP_CODE.CREATED:
    case HTTP_CODE.NO_CONTENT:
      console.log(
        `[API] ${started} - completed after: ${Date.now() - started}ms`
      );
      if (beforeCompleted) {
        yield beforeCompleted(payload);
      }
      yield put(completed(payload, started));
      break;
    default:
      console.log(`[API] ${started} - failed after: ${Date.now() - started}ms`);
      if (failed) {
        yield put(failed(response.body));
      }
      return;
  }
}

export function* genericMultipleApiSaga({ completed, failed, gatewayCalls }) {
  const responses = yield all(gatewayCalls.map(item => call(item)));
  const responseStatuses = responses.map(r => r.status);
  const responseBodies = responses.map(r => r.body);

  if (responseStatuses.every(status => status === 200)) {
    yield put(completed(responseBodies));
  } else {
    yield put(failed(responseBodies));
  }
}
export default genericApiSaga;
